import React, { useState } from 'react';
import ContainerComponent from '../../helpers/components/container.component';
import StaffLayout from './components/staff_layout';
import { useLocation } from 'react-router-dom';
import './staff.css';

const StaffIndex = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const [filter, setFilter] = useState({
        page : (queryParams.get("page")),
        parks : queryParams.get("parks")?.split(',')?.map(Number)?.filter(x => x != 0),
        status : JSON.parse(queryParams.get("status")),
        search : queryParams.get("search"),
    })

    return (
        <>
            <ContainerComponent span={22} top={20} bottom={20}>
                <StaffLayout default_filter={filter} />
            </ContainerComponent>
        </>
    );
}

export default StaffIndex;